/* PlanetMist interactions: scent finder, product tabs, delivery estimate,
   frequently bought together, sticky add to cart, one-tap add buttons. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || 'Rs.{{amount_no_decimals_with_comma_separator}}';
    var value = Number(cents) || 0;
    function withDelimiters(num, precision, thousands, decimal) {
      var fixed = (num / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals': out = withDelimiters(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = withDelimiters(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = withDelimiters(value, 0, ',', '.'); break;
      case 'amount_with_apostrophe_separator': out = withDelimiters(value, 2, "'", '.'); break;
      default: out = withDelimiters(value, 2, ',', '.');
    }
    out = out.replace(/\.00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function splitTitle(title) {
    var m = String(title || '').match(/^(.*?)[\s\-–|:]*\bour\s+imp\w*\s+of\s+(.+)$/i);
    if (!m) return { name: title, inspired: '' };
    return { name: m[1].trim() || title, inspired: m[2].trim() };
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Cart ---------- */
  function addToCart(items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'This item could not be added.');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pm-theme', cartData: data });
        }
        if (drawer && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        }
        return data;
      });
  }

  document.addEventListener('click', function (event) {
    var single = event.target.closest('[data-pm-add]');
    var many = event.target.closest('[data-pm-add-many]');
    var btn = single || many;
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var ids = single ? [single.getAttribute('data-pm-add')] : many.getAttribute('data-pm-add-many').split(',');
    var items = ids.filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    addToCart(items)
      .catch(function (err) { window.alert(err.message); })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      });
  });

  /* ---------- Review-app contrast repair ----------
     The review app is configured for a dark background (light text), which is
     right for this theme. The broken part is its own white pill controls,
     where that light text disappears. Rather than guessing which tags the app
     uses, this walks every element in the app section, measures its real
     background colour, and gives dark text only to the ones that are actually
     light. It also reaches into shadow roots, which a stylesheet cannot. */
  var PM_DARK_TEXT_RULES =
    '.pm-app-dark-text, .pm-app-dark-text * { color: #1b1411 !important; }' +
    '.pm-app-dark-text::placeholder, .pm-app-dark-text *::placeholder { color: rgba(27,20,17,.55) !important; }' +
    '.pm-app-meter { background-color: rgba(200,161,90,.2) !important; border-radius: 999px !important; overflow: hidden; }' +
    '.pm-app-meter > * { background-color: #c8a15a !important; border-radius: 999px !important; }';

  function isLightBackground(colour) {
    var m = /rgba?\((\d+)[,\s]+(\d+)[,\s]+(\d+)(?:[,\s/]+([\d.]+))?\)/.exec(colour || '');
    if (!m) return false;
    if (m[4] !== undefined && parseFloat(m[4]) < 0.5) return false;
    var luminance = (0.299 * +m[1] + 0.587 * +m[2] + 0.114 * +m[3]) / 255;
    return luminance > 0.6;
  }

  function isMeterBar(el) {
    if (!el.getBoundingClientRect || (el.textContent || '').trim() !== '') return false;
    if (el.querySelector('img, svg, picture')) return false;
    var box = el.getBoundingClientRect();
    if (box.height < 4 || box.height > 20) return false;
    if (box.width < 40 || box.width / box.height < 4) return false;
    var styles = getComputedStyle(el);
    return isLightBackground(styles.backgroundColor);
  }

  function isAppNode(el) {
    var tag = (el.tagName || '').toLowerCase();
    if (tag.indexOf('quoli') === 0 || tag.indexOf('jdgm') === 0 || tag.indexOf('judgeme') === 0) return true;
    var cls = typeof el.className === 'string' ? el.className : '';
    return /quoli|jdgm|judgeme/i.test(cls) || /quoli|jdgm|judgeme/i.test(el.id || '');
  }

  function repairWithin(root, depth) {
    if (!root || depth > 4) return;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.shadowRoot) {
        if (!el.shadowRoot.querySelector('style[data-pm-contrast]')) {
          var style = document.createElement('style');
          style.setAttribute('data-pm-contrast', '');
          style.textContent = PM_DARK_TEXT_RULES;
          el.shadowRoot.appendChild(style);
        }
        repairWithin(el.shadowRoot, depth + 1);
      }
      // The app's rating bars come through as white tracks. Tag them so the
      // stylesheet can put them in brass, matching the stars.
      if (el.classList && !el.classList.contains('pm-app-meter') && isMeterBar(el)) {
        el.classList.add('pm-app-meter');
        continue;
      }
      if (el.classList && el.classList.contains('pm-app-dark-text')) continue;
      // Leave the theme's own components alone.
      if (el.closest && el.closest('.pm-fbt, .pm-upsell, .pm-sticky-atc, .button')) continue;
      var bg;
      try {
        bg = getComputedStyle(el).backgroundColor;
      } catch (e) {
        continue;
      }
      if (isLightBackground(bg)) el.classList.add('pm-app-dark-text');
    }
  }

  function repairAppContrast() {
    // Only ever touch markup inside the app's own root element, never the
    // theme's markup that happens to share a section with it.
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      var nodes = section.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (!isAppNode(el)) continue;
        if (el.closest('product-info, .product__info-container')) continue;
        var outermost = true;
        for (var parent = el.parentElement; parent && parent !== section; parent = parent.parentElement) {
          if (isAppNode(parent)) {
            outermost = false;
            break;
          }
        }
        if (outermost) repairWithin(el, 0);
      }
    });
  }

  function scheduleContrastRepair() {
    if (window.requestAnimationFrame) requestAnimationFrame(repairAppContrast);
    else repairAppContrast();
  }

  scheduleContrastRepair();
  document.addEventListener('DOMContentLoaded', scheduleContrastRepair);
  window.addEventListener('load', scheduleContrastRepair);
  [600, 1500, 3000].forEach(function (delay) {
    setTimeout(scheduleContrastRepair, delay);
  });
  if ('MutationObserver' in window) {
    var pmAppTimer = null;
    new MutationObserver(function () {
      clearTimeout(pmAppTimer);
      pmAppTimer = setTimeout(scheduleContrastRepair, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- Scent finder ---------- */
  if (!customElements.get('pm-finder')) {
    customElements.define(
      'pm-finder',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input[type="search"]');
          this.results = this.querySelector('.pm-finder__results');
          this.format = this.dataset.currencyFormat;
          this.whatsapp = this.dataset.whatsapp;
          this.limit = Number(this.dataset.limit) || 5;
          this.active = -1;
          this.timer = null;
          this.controller = null;
          if (!this.input || !this.results) return;

          this.input.addEventListener('input', () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.search(this.input.value.trim()), 180);
          });
          this.input.addEventListener('keydown', (e) => this.onKey(e));
          this.input.addEventListener('focus', () => {
            if (this.results.innerHTML && this.input.value.trim().length > 1) this.open();
          });
          document.addEventListener('click', (e) => {
            if (!this.contains(e.target)) this.close();
          });
        }

        search(term) {
          if (term.length < 2) return this.close();
          if (this.controller) this.controller.abort();
          this.controller = new AbortController();
          var url =
            ((window.routes && window.routes.predictive_search_url) || root + 'search/suggest') +
            '.json?q=' + encodeURIComponent(term) +
            '&resources[type]=product&resources[limit]=' + this.limit +
            '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
          fetch(url, { signal: this.controller.signal })
            .then((r) => r.json())
            .then((data) => this.render(term, (data.resources && data.resources.results && data.resources.results.products) || []))
            .catch((err) => { if (err.name !== 'AbortError') this.close(); });
        }

        render(term, products) {
          var searchUrl = ((window.routes && window.routes.search_url) || root + 'search') + '?type=product&q=' + encodeURIComponent(term);
          if (!searchUrl.includes('/search')) searchUrl = root + 'search?type=product&q=' + encodeURIComponent(term);
          var html;
          if (!products.length) {
            var waLink = this.whatsapp
              ? ' or <a href="' + this.whatsapp + '?text=' + encodeURIComponent('Hi PlanetMist, do you have an impression of ' + term + '?') + '" target="_blank" rel="noopener">ask us on WhatsApp</a>'
              : '';
            html =
              '<p class="pm-finder__empty">We don\'t have an impression of "' + escapeHtml(term) + '" yet. ' +
              '<a href="' + searchUrl + '">Search all scents</a>' + waLink + '.</p>';
          } else {
            html = products
              .map((p, i) => {
                var parts = splitTitle(p.title);
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
                var imgUrl = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
                var price = Math.round(parseFloat(p.price) * 100);
                return (
                  '<a class="pm-finder__result" role="option" id="' + this.results.id + '-' + i + '" aria-selected="false" href="' + p.url + '">' +
                  (imgUrl ? '<img src="' + imgUrl + '" alt="" width="56" height="56" loading="lazy">' : '<span></span>') +
                  '<span><span class="pm-finder__rname">' + escapeHtml(parts.name) + '</span>' +
                  (parts.inspired ? '<span class="pm-finder__rinsp">Our impression of ' + escapeHtml(parts.inspired) + '</span>' : '') +
                  '</span>' +
                  '<span class="pm-finder__rprice">' + (isNaN(price) ? '' : formatMoney(price, this.format)) + '</span>' +
                  '</a>'
                );
              })
              .join('');
            html += '<a class="pm-finder__all" href="' + searchUrl + '">See every result for "' + escapeHtml(term) + '"</a>';
          }
          this.results.innerHTML = html;
          this.active = -1;
          this.open();
        }

        onKey(e) {
          var options = Array.from(this.results.querySelectorAll('.pm-finder__result'));
          if (e.key === 'Escape') return this.close();
          if (!options.length || this.results.hidden) return;
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            this.active = (this.active + (e.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
            options.forEach((o, i) => o.setAttribute('aria-selected', i === this.active ? 'true' : 'false'));
            this.input.setAttribute('aria-activedescendant', options[this.active].id);
          } else if (e.key === 'Enter' && this.active > -1) {
            e.preventDefault();
            window.location.href = options[this.active].href;
          }
        }

        open() {
          this.results.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
        }

        close() {
          this.results.hidden = true;
          this.input.setAttribute('aria-expanded', 'false');
          this.input.removeAttribute('aria-activedescendant');
        }
      }
    );
  }

  /* ---------- Tabs ---------- */
  if (!customElements.get('pm-tabs')) {
    customElements.define(
      'pm-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => {
              if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
              e.preventDefault();
              var next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });
        }
        select(index) {
          this.tabs.forEach((tab, i) => {
            var on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.setAttribute('tabindex', on ? '0' : '-1');
            var panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (panel) {
              panel.hidden = !on;
              if (on) {
                var track = panel.querySelector('[data-pm-rail]');
                if (track) track.scrollLeft = 0;
              }
            }
          });
        }
      }
    );
  }

  /* ---------- Delivery estimate ---------- */
  function pakistanNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Karachi', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(new Date());
    var get = function (t) { return Number((parts.find(function (p) { return p.type === t; }) || {}).value); };
    return { date: new Date(get('year'), get('month') - 1, get('day')), hour: get('hour') % 24, minute: get('minute') };
  }

  function addWorkingDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++;
    }
    return d;
  }

  if (!customElements.get('pm-delivery')) {
    customElements.define(
      'pm-delivery',
      class extends HTMLElement {
        connectedCallback() {
          this.textEl = this.querySelector('[data-pm-delivery-text]');
          if (!this.textEl) return;
          this.update();
          if (Number(this.dataset.cutoff) > 0) this.interval = setInterval(() => this.update(), 30000);
        }
        disconnectedCallback() { clearInterval(this.interval); }
        update() {
          var min = Number(this.dataset.min) || 2;
          var max = Math.max(Number(this.dataset.max) || 5, min);
          var cutoff = Number(this.dataset.cutoff) || 0;
          var now = pakistanNow();
          var fmt = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
          var from = fmt.format(addWorkingDays(now.date, min));
          var to = fmt.format(addWorkingDays(now.date, max));
          var html = escapeHtml(this.dataset.prefix || 'Order now and it should arrive') + ' between <strong>' + from + '</strong> and <strong>' + to + '</strong>';
          if (cutoff > 0 && now.date.getDay() !== 0) {
            var minutesLeft = cutoff * 60 - (now.hour * 60 + now.minute);
            if (minutesLeft > 0) {
              var h = Math.floor(minutesLeft / 60);
              var m = minutesLeft % 60;
              html += '<span class="pm-delivery__cut">Order in the next ' + (h ? h + 'h ' : '') + m + 'm and we dispatch today</span>';
            }
          }
          this.textEl.innerHTML = html;
        }
      }
    );
  }

  /* ---------- Frequently bought together ---------- */
  if (!customElements.get('pm-fbt')) {
    customElements.define(
      'pm-fbt',
      class extends HTMLElement {
        connectedCallback() {
          this.format = this.dataset.moneyFormat;
          this.list = this.querySelector('[data-pm-fbt-list]');
          this.totalEl = this.querySelector('[data-pm-fbt-total]');
          this.button = this.querySelector('[data-pm-fbt-add]');
          this.label = this.querySelector('[data-pm-fbt-label]');
          this.baseLabel = this.label ? this.label.textContent : '';
          this.errorEl = this.querySelector('.pm-fbt__error');
          this.main = this.querySelector('[data-pm-fbt-main]');

          this.addEventListener('change', (e) => { if (e.target.matches('[data-pm-fbt-extra]')) this.refresh(); });
          if (this.button) this.button.addEventListener('click', () => this.submit());

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              var v = event.data && event.data.variant;
              if (!v || !this.main || event.data.sectionId !== this.dataset.sectionId) return;
              this.main.dataset.variantId = v.id;
              this.main.dataset.price = v.price;
              var priceEl = this.querySelector('[data-pm-fbt-main-price]');
              if (priceEl) priceEl.textContent = formatMoney(v.price, this.format);
              this.refresh();
            });
          }

          if (this.hasAttribute('data-recommend')) this.loadRecommendations();
          else this.refresh();
        }

        disconnectedCallback() { if (this.unsub) this.unsub(); }

        loadRecommendations() {
          fetch(this.dataset.recommendationsUrl)
            .then((r) => r.json())
            .then((data) => {
              var picks = (data.products || [])
                .filter((p) => p.available && String(p.id) !== this.dataset.productId)
                .slice(0, 2);
              if (!picks.length) {
                this.classList.remove('is-loading');
                this.classList.add('is-empty');
                return;
              }
              picks.forEach((p) => {
                var variant = (p.variants || []).find((v) => v.available) || p.variants[0];
                var parts = splitTitle(p.title);
                var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=140' : '';
                var li = document.createElement('li');
                li.className = 'pm-fbt__item';
                li.innerHTML =
                  '<label class="pm-fbt__check"><input type="checkbox" checked data-pm-fbt-extra data-price="' + variant.price + '" data-variant-id="' + variant.id + '" aria-label="Add ' + escapeHtml(p.title) + '">' +
                  '<span class="pm-fbt__box" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.4 4.4L19 7.3"/></svg></span></label>' +
                  '<a href="' + p.url + '" class="pm-fbt__media" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + img + '" alt="" width="70" height="70" loading="lazy">' : '') + '</a>' +
                  '<span class="pm-fbt__info"><a href="' + p.url + '" class="pm-fbt__name">' + escapeHtml(parts.name) + '</a>' +
                  (parts.inspired ? '<span class="pm-fbt__inspired">Our impression of ' + escapeHtml(parts.inspired) + '</span>' : '') +
                  '<span class="pm-fbt__price">' + formatMoney(variant.price, this.format) + '</span></span>';
                this.list.appendChild(li);
              });
              this.classList.remove('is-loading');
              this.refresh();
            })
            .catch(() => {
              this.classList.remove('is-loading');
              this.classList.add('is-empty');
            });
        }

        selected() {
          return Array.from(this.querySelectorAll('[data-pm-fbt-main], [data-pm-fbt-extra]:checked'));
        }

        refresh() {
          var boxes = this.selected();
          var total = boxes.reduce((sum, b) => sum + Number(b.dataset.price || 0), 0);
          if (this.totalEl) this.totalEl.textContent = formatMoney(total, this.format);
          if (this.label) {
            this.label.textContent = boxes.length > 1 ? 'Add ' + boxes.length + ' to cart' : this.baseLabel;
          }
        }

        submit() {
          var form = document.querySelector('#product-form-' + this.dataset.sectionId + ' input[name="id"]');
          if (form && this.main) this.main.dataset.variantId = form.value;
          var items = this.selected().map((b) => ({ id: Number(b.dataset.variantId), quantity: 1 }));
          if (this.errorEl) this.errorEl.hidden = true;
          this.button.disabled = true;
          this.button.setAttribute('aria-busy', 'true');
          addToCart(items)
            .catch((err) => {
              if (this.errorEl) {
                this.errorEl.textContent = err.message;
                this.errorEl.hidden = false;
              }
            })
            .finally(() => {
              this.button.disabled = false;
              this.button.removeAttribute('aria-busy');
            });
        }
      }
    );
  }

  /* ---------- Sticky add to cart ---------- */
  if (!customElements.get('pm-sticky-atc')) {
    customElements.define(
      'pm-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          var id = this.dataset.sectionId;
          this.button = this.querySelector('[data-pm-sticky-add]');
          this.priceEl = this.querySelector('[data-pm-sticky-price]');
          this.target = document.getElementById('ProductSubmitButton-' + id);
          if (!this.target || !('IntersectionObserver' in window)) return;

          this.observer = new IntersectionObserver(
            (entries) => {
              var entry = entries[0];
              var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.toggle(past);
            },
            { threshold: 0 }
          );
          this.observer.observe(this.target);

          this.button.addEventListener('click', () => {
            var live = document.getElementById('ProductSubmitButton-' + id);
            if (live && !live.disabled) live.click();
            else if (live) live.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              if (!event.data || event.data.sectionId !== id) return;
              var v = event.data.variant;
              setTimeout(() => {
                var live = document.getElementById('ProductSubmitButton-' + id);
                if (live && live !== this.target) {
                  this.observer.unobserve(this.target);
                  this.target = live;
                  this.observer.observe(live);
                }
                if (live) {
                  this.button.disabled = live.disabled;
                  var label = live.querySelector('span');
                  if (label) this.button.textContent = label.textContent.trim();
                }
                var mainPrice = document.querySelector('#price-' + id + ' .price');
                if (this.priceEl && mainPrice && v) {
                  var sale = mainPrice.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');
                  var compare = v.compare_at_price && v.compare_at_price > v.price;
                  var fmt = this.dataset.moneyFormat;
                  if (fmt) {
                    this.priceEl.innerHTML = formatMoney(v.price, fmt) + (compare ? ' <s>' + formatMoney(v.compare_at_price, fmt) + '</s>' : '');
                  } else if (sale) {
                    this.priceEl.textContent = sale.textContent.trim();
                  }
                }
              }, 60);
            });
          }
        }

        toggle(show) {
          this.classList.toggle('is-visible', show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (this.button) this.button.tabIndex = show ? 0 : -1;
          document.body.classList.toggle('pm-sticky-visible', show);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.unsub) this.unsub();
          document.body.classList.remove('pm-sticky-visible');
        }
      }
    );
  }
})();